import en from "@/locales/en"
import vi from "@/locales/vi"
import { LOCALE_VI } from "@/utils/constants"
import { useRouter } from "next/router"

const useTrans = () => {
  const { locale } = useRouter()

  const trans = locale === LOCALE_VI ? vi : en

  return trans
}

export default useTrans
